/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, August 2nd 2023, 11:00:53 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Popover from "@mui/material/Popover";

type ExportImportPopoverProps = Partial<React.ComponentProps<typeof Popover>> & {
  anchorElement: HTMLButtonElement | null;
  setAnchorElement: React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>;
};

export const OSPopover = ({ anchorElement, setAnchorElement, ...props }: ExportImportPopoverProps) => {
  const handleClose = () => {
    setAnchorElement(null);
  };

  const open = Boolean(anchorElement);
  const id = open ? "onestop-popover" : undefined;

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorElement}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      {props.children}
    </Popover>
  );
};
